module.exports = __webpack_public_path__ + "img/julian.5bcebfa9.jpg";